import { create } from "zustand";

type AppStoreState = {
  hasInitiallyFetched: boolean;
  setHasInitiallyFetched: () => void;
  isAuthenticated: boolean;
  setIsAuthenticated: (value: boolean) => void;
};

export const useAppStore = create<AppStoreState>((set) => ({
  hasInitiallyFetched: false,
  setHasInitiallyFetched: () => set({ hasInitiallyFetched: true }),
  isAuthenticated: false,
  setIsAuthenticated: (value: boolean) => set({ isAuthenticated: value }),
}));
